import React from 'react';
import { Row, Col, Button, Collapse } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  GAPurchaseMonthlyClick,
  GAPurchaseYearlyClick,
} from '@/views/account/ga/purchase';

import '@/views/account/assets/purchase.scss';

const { Panel } = Collapse;

// eslint-disable-next-line no-restricted-globals
const PurchaseRender = ({ currPackage, handleGetPurchaseURL, packageMap }) => {
  console.log(packageMap);
  const { t } = useTranslation(['purchase']);
  var freeTipsIp = '';
  const userIp = localStorage.getItem('userIp');
  if (userIp == 'A') {
    freeTipsIp = 'freeTips52';
  } else {
    freeTipsIp = 'freeTips5';
  }
  console.log('userIp:', userIp);
  /**
   *  移动端免费价格区块的头部
   */
  const freeCollapseHeaderRender = () => (
    <div className='d-flex align-items-center justify-content-between w-100'>
      <span className='package-title'>{t('free')}</span>
      <div className='d-flex align-items-center me-2'>
        <div className='price'>
          <span className='currency position-relative fw-bolder'>
            {packageMap.get('free').currency}
          </span>
          <span className='price-number fw-bold me-1'>
            {packageMap.get('free').price}
          </span>
          <span className='currency-area fw-bold'>
            {packageMap.get('free').currencyArea}
          </span>
        </div>
      </div>
    </div>
  );

  /**
   *  移动端月价格区块的头部
   */
  const monthlyCollapseHeaderRender = () => (
    <div className='d-flex align-items-center justify-content-between w-100'>
      <span className='package-title'>{t('monthlyUppercase')}</span>
      <div className='d-flex align-items-center me-2'>
        <del className='original-price py-1 px-2 me-3 tiny'>
          {packageMap.get('monthly').originalPrice}
        </del>
        <div className='price'>
          <span className='currency position-relative fw-bolder'>
            {packageMap.get('monthly').currency}
          </span>
          <span className='price-number fw-bold me-1'>
            {packageMap.get('monthly').price}
          </span>
          <span className='currency-area fw-bold'>
            {packageMap.get('monthly').currencyArea}
          </span>
        </div>
      </div>
    </div>
  );
  /**
   *  移动端年价格区块的头部
   */
  const yearlyCollapseHeaderRender = () => (
    <div className='d-flex align-items-center justify-content-between w-100'>
      <span className='package-title'>{t('yearlyUppercase')}</span>
      <div className='d-flex align-items-center me-2'>
        <del className='original-price py-1 px-2 me-3 tiny'>
          {packageMap.get('yearly').originalPrice}
        </del>
        <div className='price'>
          <span className='currency position-relative fw-bolder'>
            {packageMap.get('yearly').currency}
          </span>
          <span className='price-number fw-bold me-1'>
            {packageMap.get('yearly').price}
          </span>
          <span className='currency-area fw-bold'>
            {packageMap.get('yearly').currencyArea}
          </span>
        </div>
      </div>
    </div>
  );
  /**
   *  展开区块自定义icon
   */
  const expandIcon = (panelProps) => {
    return (
      <svg
        width='9'
        height='6'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={
          panelProps.isActive
            ? { transform: 'rotate(0deg)', transformOrigin: 'center' }
            : {
                transform: 'rotate(-90deg) translateX(3px)',
                transformOrigin: 'center',
              }
        }
      >
        <path d='M4.333 6 .292 0h8.083L4.333 6Z' fill='#8372FF' />
      </svg>
    );
  };

  return (
    <div className='container mt-5 pt-3 pt-md-5'>
      <h1 className='fw-bold text-center mb-3 mb-md-4'>{t('title')}</h1>
      <p className='text-center mb-5 pb-0 pb-md-4'>{t('subTitle')}</p>
      <Row gutter={[48, 48]} className='purchase-list mb-5 d-none d-lg-flex'>
        <Col sm={24} md={8}>
          <div className='purchase-item d-flex flex-column align-items-center justify-content-center pt-5 px-2 pb-5 mx-auto'>
            <p className='package-title'>{t('free')}</p>
            <div className='price mb-5 pb-1'>
              <span className='currency fw-bolder position-relative me-1'>
                {packageMap.get('free').currency}
              </span>
              <span className='price-number fw-bolder me-1'>
                {packageMap.get('free').price}
              </span>
              <span className='currency-area fw-bold'>
                {packageMap.get('free').currencyArea}
              </span>
            </div>
            <Button
              ghost
              size='large'
              className='fw-bolder'
              style={{ marginBottom: 92 }}
            >
              {t('inService')}
            </Button>
            <ul className='list-group v1 v1-0-2'>
              <li className='list-group-item py-0'>{t('freeTips1')}</li>
              <li className='list-group-item py-0'>{t('freeTips2')}</li>
              <li className='list-group-item py-0'>{t('freeTips3')}</li>
              <li className='list-group-item py-0'>{t('freeTips4')}</li>
              <li className='list-group-item py-0'>{t(freeTipsIp)}</li>
              <li className='list-group-item py-0'>{t('freeTips6')}</li>
            </ul>
          </div>
        </Col>
        <Col sm={24} md={8}>
          <div className='active purchase-item position-relative d-flex flex-column align-items-center justify-content-center pt-5 px-2 pb-5 mx-auto'>
            <p className='package-title'>{t('monthlyUppercase')}</p>
            <div className='price'>
              <span className='currency fw-bolder position-relative me-1'>
                {packageMap.get('monthly').currency}
              </span>
              <span className='price-number fw-bolder me-1'>
                {packageMap.get('monthly').price}
              </span>
              <span className='currency-area fw-bold'>
                {packageMap.get('monthly').currencyArea}
              </span>
            </div>
            <del className='original-price small px-2'>
              {packageMap.get('monthly').originalPrice}
            </del>
            <Button
              type='primary'
              size='large'
              className='fw-bolder'
              loading={currPackage === 'month'}
              onClick={() => {
                handleGetPurchaseURL('month');
                GAPurchaseMonthlyClick();
              }}
            >
              {t('buyBtn')}
            </Button>
            <ul className='list-group v1 v1-0-2'>
              <li className='list-group-item py-0'>{t('vipTips5')}</li>
              <li className='list-group-item py-0'>{t('vipTips1')}</li>
              <li className='list-group-item py-0'>{t('vipTips2')}</li>
              <li className='list-group-item py-0'>{t('vipTips3')}</li>
              <li className='list-group-item py-0'>{t('vipTips4')}</li>
              <li className='list-group-item py-0'>{t('vipTips6')}</li>
              <li className='list-group-item py-0'>{t('vipTips7')}</li>
            </ul>
          </div>
        </Col>
        <Col sm={24} md={8}>
          <div className='purchase-item d-flex flex-column align-items-center justify-content-center pt-5 px-2 pb-5 mx-auto'>
            <p className='package-title'>{t('yearlyUppercase')}</p>
            <div className='price'>
              <span className='currency fw-bolder position-relative me-1'>
                {packageMap.get('yearly').currency}
              </span>
              <span className='price-number fw-bolder me-1'>
                {packageMap.get('yearly').price}
              </span>
              <span className='currency-area fw-bold'>
                {packageMap.get('yearly').currencyArea}
              </span>
            </div>
            <del className='original-price small px-2'>
              {packageMap.get('yearly').originalPrice}
            </del>
            <Button
              type='primary'
              size='large'
              className='fw-bolder'
              loading={currPackage === 'year'}
              onClick={() => {
                handleGetPurchaseURL('year');
                GAPurchaseYearlyClick();
              }}
            >
              {t('buyBtn')}
            </Button>
            <ul className='list-group v1 v1-0-2'>
              <li className='list-group-item py-0'>{t('vipTips5')}</li>
              <li className='list-group-item py-0'>{t('vipTips1')}</li>
              <li className='list-group-item py-0'>{t('vipTips2')}</li>
              <li className='list-group-item py-0'>{t('vipTips3')}</li>
              <li className='list-group-item py-0'>{t('vipTips4')}</li>
              <li className='list-group-item py-0'>{t('vipTips6')}</li>
              <li className='list-group-item py-0'>{t('vipTips7')}</li>
            </ul>
          </div>
        </Col>
      </Row>
      <Collapse
        defaultActiveKey={['monthly']}
        expandIconPosition='right'
        bordered={false}
        expandIcon={expandIcon}
        className='purchase-collapse mb-5 d-block d-lg-none'
      >
        <Panel header={freeCollapseHeaderRender()} key='free'>
          <ul className='list-group v1 v1-0-2'>
            <li className='list-group-item py-0 ps-0'>{t('freeTips1')}</li>
            <li className='list-group-item py-0 ps-0'>{t('freeTips2')}</li>
            <li className='list-group-item py-0 ps-0'>{t('freeTips3')}</li>
            <li className='list-group-item py-0 ps-0'>{t('freeTips4')}</li>
            <li className='list-group-item py-0 ps-0'>{t('freeTips5')}</li>
            <li className='list-group-item py-0 ps-0'>{t('freeTips6')}</li>
          </ul>
          <Button
            ghost
            size='large'
            className='fw-bolder mx-auto d-block my-4'
            disabled
          >
            {t('inService')}
          </Button>
        </Panel>
        <Panel
          header={monthlyCollapseHeaderRender()}
          key='monthly'
          className='active'
        >
          <ul className='list-group v1 v1-0-2'>
            <li className='list-group-item py-0 ps-0'>{t('vipTips5')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips1')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips2')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips3')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips4')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips6')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips7')}</li>
          </ul>
          <Button
            loading={currPackage === 'month'}
            onClick={() => {
              handleGetPurchaseURL('month');
              GAPurchaseMonthlyClick();
            }}
            type='primary'
            size='large'
            className='fw-bolder mx-auto d-block my-4'
          >
            {t('buyBtn')}
          </Button>
        </Panel>
        <Panel header={yearlyCollapseHeaderRender()} key='yearly'>
          <ul className='list-group v1 v1-0-2'>
            <li className='list-group-item py-0 ps-0'>{t('vipTips5')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips1')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips2')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips3')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips4')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips6')}</li>
            <li className='list-group-item py-0 ps-0'>{t('vipTips7')}</li>
          </ul>
          <Button
            loading={currPackage === 'year'}
            onClick={() => {
              handleGetPurchaseURL('year');
              GAPurchaseYearlyClick();
            }}
            type='primary'
            size='large'
            className='fw-bolder mx-auto d-block my-4'
          >
            {t('buyBtn')}
          </Button>
        </Panel>
      </Collapse>
      <div className='d-flex flex-column align-items-center justify-content-center mb-5 pb-5'>
        <span className='mb-3 fw-bold'>{t('acceptTitle')}</span>
        <div className='d-flex justify-content-center flex-wrap'>
          <img
            className=' mt-2 mt-lg-0'
            width='58'
            src='https://images.hitpaw.com/images/purchases/bottom-card-icon1.svg'
            alt='bank card'
          />
          <img
            className='ms-lg-4 ms-3 mt-2 mt-lg-0'
            width='58'
            src='https://images.hitpaw.com/images/purchases/bottom-card-icon2.svg'
            alt='bank card'
          />
          <img
            className='ms-lg-4 ms-3 mt-2 mt-lg-0'
            width='58'
            src='https://images.hitpaw.com/images/purchases/bottom-card-icon3.svg'
            alt='bank card'
          />
          <img
            className='ms-lg-4  ms-3 mt-2 mt-lg-0'
            width='58'
            src='https://images.hitpaw.com/images/purchases/bottom-card-icon4.svg'
            alt='bank card'
          />
          <img
            className='ms-lg-4 ms-3 mt-2 mt-lg-0'
            width='58'
            src='https://images.hitpaw.com/images/purchases/bottom-card-icon5.svg'
            alt='bank card'
          />
          <img
            className='ms-lg-4 ms-3 mt-2 mt-lg-0'
            width='58'
            src='https://images.hitpaw.com/images/purchases/bottom-card-icon6.svg'
            alt='bank card'
          />
          <img
            className='ms-lg-4 ms-3  mt-2 mt-lg-0'
            width='58'
            src='https://images.hitpaw.com/images/purchases/bottom-card-icon7.svg'
            alt='bank card'
          />
        </div>
      </div>
    </div>
  );
};

export default PurchaseRender;
